import { FC } from 'react';
import { useIntl } from 'react-intl';

import { PageTitle } from '../../../_metronic/layout/core';
import ScheduledOfferResultsTable from '../../modules/scheduled-offers/components/ScheduledOfferResultsTable';

export const ScheduledOfferResultsPage: FC = () => {
  const intl = useIntl();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'promoResults.title' })}
      </PageTitle>
      <ScheduledOfferResultsTable />
    </>
  );
};
